<template>
  <div class="">
    <div class="pa-4" style="background-color: #ecf1f2">
      <div class="d-flex justify-space-between align-center">
        <div>
          <h1>
            Comments <span class="ml-2">({{ GetTotalBlogsComment }})</span>
          </h1>
        </div>
        <div class="d-flex">
          <v-icon
            style="color: rgba(8, 8, 22, 0.6)"
            @click="cancel"
            class="ml-8"
            >mdi-close</v-icon
          >
        </div>
      </div>
      <div class="d-flex my-1">
        <v-card style="width: 5.5rem" flat color="transparent">
          <v-img :src="commentData.Banner"></v-img>
        </v-card>

        <span class="ml-7"
          ><b>{{ commentData.Title }}</b></span
        >
      </div>
    </div>
    <div class="pa-5 pt-0">
      <div class="my-3">
        <v-row class="mt-6">
          <v-col cols="12" md="8" sm="6">
            <v-card flat>
              <v-text-field
                flat
                dense
                background-color="#ECF1F2"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                v-model="search"
                hide-details
                single-line
                solo
              ></v-text-field>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div>
        <div
          v-for="(comment, index) in filteredComments"
          :key="index"
          class="my-5"
        >
          <div>
            <div class="d-flex">
              <v-card flat color="transparent" class="mt-1">
                <img
                  style="height: 45px; width: 45px; object-fit: cover;object-position: center; background-color: white;"
                  :src="
                    comment.SubmittedByProfileImage ||
                    'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
                  "
                  @error="setDefaultImage"
                />
              </v-card>
              <div class="ml-3" style="width: 100%">
                <div class="d-flex justify-space-between">
                  <div>
                    <div>
                      <b> {{ comment.SubmittedByName }}</b>
                    </div>
                    <div>
                      <span class="date_style">{{
                        comment.CreatedDate.split("T")[0]
                      }}</span>
                    </div>
                  </div>

                  <div>
                    <span
                      v-if="!comment.isViewed"
                      style="color: #bc7410"
                      class="cursor-pointer"
                      >New comment</span
                    >
                    <v-icon
                      color="red"
                      class="mx-4 cursor-pointer"
                      @click="deletedialogBlock(comment.Id)"
                      >mdi-delete-forever</v-icon
                    >
                    <v-btn icon @click="toggleIsPlaying(comment.Id)">
                      <v-icon
                        v-if="comment.isPublished"
                        color="primary"
                        class="cursor-pointer"
                        >mdi-eye</v-icon
                      >
                      <v-icon v-else>mdi-eye-off</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-4">
              <span
                style="color: #363636; font-size: 13px"
                v-html="comment.Comment"
              >
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="my-4 d-flex justify-center">
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          @input="fetchData()"
        ></v-pagination>
      </div>
    </div>

    <!-- Delete dialog -->
    <v-dialog v-model="deletedialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">Warning</v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deletedialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="btnloader"
            @click="deletedialogConfirm"
          >
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Comment",
  props: ["commentData"],
  data() {
    return {
      btnloader: false,
      totalRecords: 0,
      currentPage: 1,
      itemsPerPage: 5,
      pageNumber: 1,
      search: null,
      DeleteId: 0,
      blogCommentId: 0,
      ArchivedDialog: false,
      deletedialog: false,
      filterItem: [
        {
          text: "By Status (Active, inactive, New comment)",
        },
        {
          text: "By Date",
        },
      ],
    };
  },

  methods: {
    setDefaultImage(event) {
      event.target.src = 'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
    },
    toggleIsPlaying(obj) {
      var data = new FormData();
      data.append("Id", obj);
      this.$store.dispatch("SetVisibilityComments", data).then(() => {
        this.$store.dispatch("GetBlogsComments", {
          search: null,
          pageNumber: 1,
          Id: this.SelectedBlog,
        });
      });
    },

    async fetchData() {
      var obj = {
        search: this.search,
        pageNumber: this.currentPage,
        Id: this.SelectedBlog,
      };
      await this.$store.dispatch("GetBlogsComments", obj).then((res) => {
        if (res.Status) {
          this.totalRecords = res.Data.totalRecords;
          this.currentPage = res.Data.page;
        }
      });
    },

    async deletedialogConfirm() {
      this.btnloader = true;
      this.$store.dispatch("DeleteBlogComment", this.DeleteId).then((res) => {
        if (res.Status) {
          this.deletedialog = false;
          this.btnloader = false;
          Swal.fire({
            icon: "success",
            text: "Comment deleted successfully.",
          }).then(() => {
            this.fetchData();
          });
        }
      });
    },

    deletedialogBlock(Id) {
      this.DeleteId = Id;
      this.deletedialog = true;
    },

    cancel() {
      this.$emit("close");
    },
  },
  watch: {
    search() {
      this.fetchData();
    },
  },
  computed: {
    ...mapGetters(["GetBlogsComments", "GetTotalBlogsComment", "SelectedBlog"]),
    totalPages() {
      return Math.ceil(this.GetTotalBlogsComment / this.itemsPerPage);
    },

    filteredComments() {
      if (!this.search) {
        return this.GetBlogsComments;
      } else {
        const searchTerm = this.search.toLowerCase();
        return this.GetBlogsComments.filter((comment) =>
          comment.Comment.toLowerCase().includes(searchTerm)
        );
      }
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: "DM Sans";
  font-size: 24px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
}

.date_style {
  font-family: "DM Sans";
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
}
</style>
